<script lang="ts">
    import {Component, mixins, Prop, toNative} from 'vue-facing-decorator'
    import BookingPageBase from '~src/components/parts/bookingPageBase.src'
    import {SimpleTourMixin} from '@/mixins/SimpleTourMixin.vue'
    import BookingPageMixin from '~src/mixins/BookingPageMixin.vue'
    import {callComponentMethod} from '~/utils/vue-class-helpers'

    @Component({mixins: [BookingPageBase]})
    export class SimpleTourBookingPageLayout extends mixins(SimpleTourMixin) {
        @Prop({required: true}) product

        prepareBookRequest(specifiedTouristBookingFields, includeOptionalTourists = false) {
            const prepareBookRequest = callComponentMethod(
                this,
                BookingPageMixin,
                'prepareBookRequest',
                specifiedTouristBookingFields,
                includeOptionalTourists
            )
            return prepareBookRequest
        }

        get productSearchPageName() {
            return 'simpleTourSearch'
        }

        get productConfirmationPageName() {
            return 'simpleTourConfirmation'
        }

        get productName() {
            return 'tour'
        }

        get productBookingPageName() {
            return 'simpleTourBooking'
        }

        get corporatePolicyType() {
            return null
        }

        get touristToken() {
            return 'guest'
        }

        get startDate() {
            return this.offer.date
        }

        get showAddOns() {
            return false
        }
    }

    export default {...toNative(SimpleTourBookingPageLayout), ssrRender: BookingPageBase.ssrRender}
</script>
